import { UserOperationModesModal } from '@view-model/models/sticky/userOperationModes/components/UserOperationModesModal';
import { Button } from './Button';
import { faExpand, faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
type Props = {
  onZoomIn: () => void;
  onZoomOut: () => void;
  onZoomReset: () => void;
};

export const FooterMenu: React.FC<Props> = ({ onZoomIn, onZoomOut, onZoomReset }: Props) => {
  const { t } = useTranslation();
  const [isModalOpen, setModalOpen] = useState<boolean>(false);

  // 操作モード設定ダイアログ関連のハンドラ
  const handleOpenModal = useCallback(() => setModalOpen(true), []);
  const handleCloseModal = useCallback(() => setModalOpen(false), []);

  return (
    <>
      <div className="flex gap-2">
        <Button
          caption={t('viewModel.footerMenu.operationMode')}
          tooltip={t('viewModel.operationMode.label')}
          className="rounded-lg"
          onClick={handleOpenModal}
        />
        <div className="flex gap-1">
          <Button
            icon={faMinus}
            tooltip={t('viewModel.footerMenu.zoomOut')}
            className="rounded-l-lg"
            onClick={onZoomOut}
          />
          <Button
            icon={faPlus}
            tooltip={t('viewModel.footerMenu.zoomIn')}
            className="rounded-r-lg"
            onClick={onZoomIn}
          />
        </div>
        <Button
          icon={faExpand}
          tooltip={t('viewModel.footerMenu.zoomToFit')}
          className="rounded-lg"
          onClick={onZoomReset}
        />
      </div>
      <UserOperationModesModal isOpen={isModalOpen} onClose={handleCloseModal} />
    </>
  );
};
